<template>
  <v-autocomplete
    outlined
    dense
    v-model="inputValue"
    v-bind:label="$t('info_card.nation')"
    v-bind:item-text="(item) => objectTranslator(item, 'NATION_NAME')"
    v-bind:items="nations"
    v-bind:item-value="(item) => item.NATION_ID"
    v-bind:rules="nationRules"
  ></v-autocomplete>
</template>

<script>
import { objectTranslator } from "../../helper/translator";
import validator from "../../helper/validator";

export default {
  name: "NationoCard",
  props: ["value"],

  data() {
    return {
      nationRules: [validator.required],
    };
  },
  methods: {
    objectTranslator,
  },
  computed: {
    nations: function() {
      return this.$store.state.ref.nations;
    },

    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  mounted: function() {
    this.$store.dispatch("ref/getNations");
  },
};
</script>
